import React from "react";
import { useModelIndex } from "@rhino-project/core/hooks";
import { Badge } from "../components/ui/badge";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Separator } from "../components/ui/separator";

export default function About() {
  useModelIndex("knowledge_record" as any, { limit: 1 } as any);
  return (
    <div className="w-full min-w-0 overflow-x-hidden">
      <div className="flex w-full min-w-0 flex-col gap-6">
          <section className="space-y-4">
      <h1 className="text-2xl font-semibold">About The Third Door</h1>
      <Card>
      <CardHeader>
      <CardTitle>Mission Overview</CardTitle>
      <CardDescription>Enable innovative companies to enter defence procurement with confidence.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
      {[
      "Dual-use entry point",
      "Trusted triage",
      "Actionable routing",
      ].map((pillar) => (
      <div key={pillar} className="flex items-center gap-2"><Badge variant="secondary">Pillar</Badge><span className="text-sm text-foreground">{pillar}</span></div>
      ))}
      <Separator />
      <p className="text-sm text-muted-foreground">Built to support applicants, navigators, sponsors, and defence program teams.</p>
      </CardContent>
      </Card>
      </section>
  <section className="space-y-4">
      <h2 className="text-xl font-semibold">Ecosystem Alignment</h2>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      {[
      "https://pixabay.com/get/g3add05b92cce24935e918ae5dfa62d825b809e1bc88aa0d580efb0049bc673eb377e1036ec6cf09afdb132b40514fc278e7800d2215ffe8c53cca3c873f806ac_640.jpg",
      "https://pixabay.com/get/ga0dbbb374cf4b5332459c186acb3b7a244a5e64fcd8cded88588079827cac4ca734f503c530f32c8b440252b7d782c8c042b2ce2e656e31750ef950a364665de_640.jpg",
      "https://pixabay.com/get/gffce8a77a6deb32797a3c2bf2cf2b275ec5c93bfd62ac86379b07c5c81c8c495cd16bf56965fcce9ab41e41076f2f6eb5d7dac3fac3e4a1957a5a93750e16cc9_640.jpg",
      ].map((src, index) => (
      <Card key={src} className="overflow-hidden">
      <img src={src} alt={`Ecosystem partner ${index + 1}`} className="h-40 w-full object-cover" />
      <CardContent className="p-3"><Badge variant="outline">Aligned partner network</Badge></CardContent>
      </Card>
      ))}
      </div>
      </section>
      </div>
    </div>
  );
}